import { render } from "./RegisterPettyCashMovement.vue?vue&type=template&id=d18b1dfa"
import script from "./RegisterPettyCashMovement.vue?vue&type=script&lang=js"
export * from "./RegisterPettyCashMovement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__